import {
    checkInEventZodUnion,
    checkInStatusEventFactory,
} from "@@/shared/statuses/reservation-check-ins/events/check-in.event";
import type { z } from "zod";

const statusEventZodUnion = checkInEventZodUnion; // only one yet

type StatusEvent = z.infer<typeof statusEventZodUnion>;
type StatusEventType = StatusEvent["type"];

const statusEventFactory = {
    checkIn: checkInStatusEventFactory,
};

export { statusEventFactory, statusEventZodUnion };
export type { StatusEvent, StatusEventType };
